var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userAllowedImportExport)?_c(_vm.componentName,{tag:"component"}):_c('NoImportExportPermission')}
var staticRenderFns = []

export { render, staticRenderFns }